// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductBasketItems_list__Lw1bW","listItem":"ProductBasketItems_listItem__gASIL","text":"ProductBasketItems_text__MjJzC"};